// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"search-input_inputWrapper__3wWyb","searchInput":"search-input_searchInput__3cElO","searchDelete":"search-input_searchDelete__3pIaO"};